import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class Location {
  constructor(init) {
    if (isNil(init)) return undefined
    this._address_1 = init.address_1
    this._address_2 = init.address_2
    this._city = init.city
    this._state = init.state
    this._zip = init.zip
  }

  static shape = {
    address_1: PropTypes.string.isRequired,
    address_2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired
  }

  get address_1() {
    return this._address_1
  }

  get address_2() {
    return this._address_2
  }

  get city() {
    return this._city
  }

  get state() {
    return this._state
  }

  get zip() {
    return this._zip
  }
}

export default Location
